import type { ChatbotState } from "@noa/client-store";
import { type FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { useActionDescription } from "@noa/client-store";
import { ChatStatusTagProcessing } from "./chat-status-tag-processing";

interface ChatbotStateTagProps {
  state: ChatbotState | null;
}
export const ChatbotStateTag: FunctionComponent<ChatbotStateTagProps> = ({ state }) => {
  const { t } = useTranslation();
  const actionDescription = useActionDescription();

  if (!state || state === "waiting") return null;

  if (state === "sending_message") {
    return <ChatStatusTagProcessing statusLabel={t("chat:status.sendingMessage")} />;
  }

  if (state === "generating_query") {
    return <ChatStatusTagProcessing statusLabel={t("chat:status.generatingQuery")} />;
  }

  if (state === "retrieving_sources") {
    // Show action description if available, otherwise show default message
    const label = actionDescription || t("chat:status.retrievingSources");
    return <ChatStatusTagProcessing statusLabel={label} />;
  }

  if (state === "streaming_answer") {
    return <ChatStatusTagProcessing statusLabel={t("chat:status.streamingAnswer")} />;
  }

  if (state === "identifying_used_sources") {
    return <ChatStatusTagProcessing statusLabel={t("chat:status.identifyingUsedSources")} />;
  }

  console.error(`[ChatbotStateTag] Unhandled state: "${state}"`);
  return null;
};
